'use client';

import { MantineProvider as BaseMantineProvider, createTheme, MantineColorsTuple } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';

// Define custom colors that match your app's design
const primary: MantineColorsTuple = [
  '#eef3ff',
  '#dce4f5',
  '#b9c7e2',
  '#94a9d0',
  '#7590c0',
  '#6180b6',
  '#5577b1',
  '#47669e',
  '#3d5a8f',
  '#324e80'
];

// Create a custom theme
const theme = createTheme({
  primaryColor: 'primary',
  colors: {
    primary
  },
  fontFamily: 'var(--font-outfit), sans-serif',
  headings: {
    fontFamily: 'var(--font-outfit), sans-serif',
  },
  components: {
    DatePicker: {
      styles: {
        monthsListControl: {
          flex: 1,
        },
        monthCell: {
          width: '100%',
        },
        day: {
          borderRadius: '4px',
        },
        calendarHeaderLevel: {
          fontSize: '1rem',
          fontWeight: 600,
        },
        calendarHeader: {
          maxWidth: 'none',
        },
        monthsList: {
          display: 'flex',
          flexDirection: 'row',
          gap: '1rem',
          justifyContent: 'space-between',
        },
        yearsList: {
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '0.5rem',
        },
      }
    }
  }
});

// Add global styles for Mantine integration with your app
const globalStyles = `
  .mantine-DatePicker-wrapper, 
  .mantine-DatePicker-calendar, 
  .mantine-DatePicker-monthCell {
    width: 100% !important;
  }

  .mantine-Calendar-calendarHeader, 
  .mantine-Calendar-monthCell {
    max-width: none !important;
  }

  .mantine-DatePicker-monthsListControl {
    flex: 1 !important;
  }
`;

export function MantineProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <style jsx global>{globalStyles}</style>
      <BaseMantineProvider theme={theme}>
        <DatesProvider settings={{ 
          locale: 'en-AU',
          firstDayOfWeek: 1, // Monday
          weekendDays: [0, 6], // Sunday and Saturday
          timezone: 'UTC' 
        }}>
          {children}
        </DatesProvider>
      </BaseMantineProvider>
    </>
  );
}
